import { ICategories } from "../models/categoriesresponse.model";
import { ISubCategories } from "../models/sub-categoriesresponse.model";

export interface ISubCategoriesState {
  SubCategories: ISubCategories;
}

export const initialSubCategoriesState: ISubCategoriesState = {
  SubCategories: null,
};
